import { render } from "./timeOutPopUp.vue?vue&type=template&id=7462f53a&scoped=true"
import script from "./timeOutPopUp.vue?vue&type=script&lang=js"
export * from "./timeOutPopUp.vue?vue&type=script&lang=js"

import "./timeOutPopUp.vue?vue&type=style&index=0&id=7462f53a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\TECHNOVA_FD01\\Desktop\\Augustine\\Projects\\XP\\payout-fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7462f53a"]])

export default __exports__